import { render, staticRenderFns } from "./face-templete-class.vue?vue&type=template&id=5934e1be&scoped=true"
import script from "./face-templete-class.vue?vue&type=script&lang=ts"
export * from "./face-templete-class.vue?vue&type=script&lang=ts"
import style0 from "./face-templete-class.vue?vue&type=style&index=0&id=5934e1be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934e1be",
  null
  
)

export default component.exports